import type { FC } from "react";

import type { ITrendsBarValue } from "../../../TrendsBar/src/TrendsBar";
import { TrendsBar } from "../../../TrendsBar/src/TrendsBar";

interface ICoreTrendCellProps {
    value: ITrendsBarValue[];
}

const CoreTrendsBarCell: FC<ICoreTrendCellProps> = ({ value }) => {
    return (
        <div style={{ width: "100%", height: 27 }}>
            <TrendsBar values={value} />
        </div>
    );
};

CoreTrendsBarCell.displayName = "CoreTrendsBarCell";

export default CoreTrendsBarCell;
